<template>
  <div style="margin:auto">
    <LineChartGenerator
      id='chartOp'
      :chart-options="chartOptions"
      :chart-data="chartData"
      :chart-id="chartId"
      :dataset-id-key="datasetIdKey"
      :plugins="plugins"
      :css-classes="cssClasses"
      :styles="styles"
      :width="width"
      :height="height"
    />
    <div id="modalpointOpex" class="row" style="position: absolute; z-index: 100; display: none;">
        <input type="number" min="0" step="0.01" id="modalNumberInputOpex" name="numberInput" class="form-control w-75">
        <button v-on:click="validateInput" type="button"  class="buttonOriginal">
          <span class="glyphicon glyphicon-ok-sign" aria-hidden="true"></span>
        </button>
    </div>
  </div>
</template>

<script>
import { Line as LineChartGenerator } from 'vue-chartjs/legacy';

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
} from 'chart.js';

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
);

const colorPoint = ['#f8f879','#f87979','#79f879','#79f8f8'];

export default {
  name: 'chartOpex',
  components: {
    LineChartGenerator
  },
  props: {
    datasetIdKey: 'label',
    width:  {
      type: Number,
      default: 1400
    },
    height: {
      type: Number,
      default: 520
    },
    cssClasses: '',
    styles: () => {},
    plugins: () => [],
    opex:  {},
    modeOpex: {},
  },
  data: function() {
    return {
      chartId: 'opex-chart',
      originalematrice:[],
      chartData: {
        labels: [],
        datasets: [
          {
            label: "",
            backgroundColor: [], //'#f8f879',
            borderColor: [], //'#f8f879',
            pointStyle: 'rectRot',
            radius:[],
            data: [],
          },
          {
            label: "",
            backgroundColor: [], //'#f87979',
            borderColor: [], //'#f87979',
            pointStyle: 'rectRot',
            radius:[],
            data: [],
          },
          {
            label: "",
            backgroundColor: [], //'#79f879',
            borderColor: [], //'#79f879',
            pointStyle: 'rectRot',
            radius:[],
            data: [],
          },
          {
            label: "",
            backgroundColor: [], //'#79f8f8',
            borderColor: [], //'#79f8f8',
            pointStyle: 'rectRot',
            radius:[],
            data: [],
          },
        ],
      },
      chartOptions: {
        events: ['mousemove', 'mouseout', 'click', 'touchstart', 'touchmove','contextmenu','drag', 'dblclick'],
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          datalabels: {
              color: 'white',
              display: false,
          },
          dragData: {
              round: 3,
              showTooltip: true,
              onDragStart: function(e, datasetIndex, index, value) {
              },
              onDrag: (e, datasetIndex, index, value)=> {   
                e.target.style.cursor = 'grabbing'
                var xIsExistIndex = -1;
                var j = 0;
                var pas = this.maxVal / 100;
                this.originalematrice[datasetIndex][1].forEach(function(elem){

                  if(index*pas==elem){
                    xIsExistIndex =j;

                  }
                  j++;
                });
                if(xIsExistIndex>-1){
                  this.originalematrice[datasetIndex][0][xIsExistIndex]=value;                  
                }else{
                  var j = 0;
                  while(index*pas>this.originalematrice[datasetIndex][1][j]){
                    j++;
                  }
                  this.originalematrice[datasetIndex][1].splice(j,0,""+index*pas);
                  this.originalematrice[datasetIndex][0].splice(j,0,value);                  
                  
                  this.chartData.datasets[datasetIndex].backgroundColor[index]= colorPoint[datasetIndex];                 
                  this.chartData.datasets[datasetIndex].radius[index]=10;                  
                }
                this.calculateDataset(datasetIndex);
                
              },
              onDragEnd: (e, datasetIndex, index, value)=> {
                e.target.style.cursor = 'default';
                document.getElementById('opex').value=JSON.stringify(this.originalematrice);
              },
            },
            legend: {
                labels: {
                    color: 'white',
                },
            },
        },
        onHover: function(e) {
          const point = e.chart.getElementsAtEventForMode(e, 'nearest', { intersect: true }, false);
          if (point.length) e.native.target.style.cursor = 'grab';
          else e.native.target.style.cursor = 'default';
        },
        onClick: this.handleRightClick,
        scales: {
            x: {
                ticks: {
                    // For a category axis, the val is the index so the lookup via getLabelForValue is needed
                    callback: function(val, index) {
                        // Hide the label of every 10th dataset
                        return index % 5 === 0 ? this.getLabelForValue(val) : '';
                    },
                    color: 'white',
                },
                grid: {
                  color: 'white'
                },
                display: true,
                title: {
                    display: true,
                    text: 'Puissance (kWc)',
                    color: 'white',
                    font: {
                        size: 20,
                        weight: 'bold',
                        lineHeight: 1.2,
                    },
                    padding: {top: 10, left: 0, right: 0, bottom: 0},
                },
            },
            y: {
                ticks: {
                    color: 'white'
                },
                display: true,
                grid: {
                  color: 'white'
                },
                title: {
                    display: true,
                    text: 'Coût d\'exploitation (€)',
                    color: 'white',
                    font: {
                        size: 20,
                        weight: 'bold',
                        lineHeight: 1.2,
                    },
                    padding: {top: 10, left: 0, right: 0, bottom: 0},
                },
            },
        },
      },
      chartWidth: 0,
      dblclickbool: false,
      tempPoint: [],
    };
  },
  computed: {
    maxVal() {      
      switch(this.modeOpex) {
        case "xs":
          return 500;
        case "m":
          return 5000;
        case "l":
          return 20000;
        case "s" : 
        default:
          return 1000;
      }
    }
  },
  mounted: function() {     
    this.updateChartOpex();   

    // mise au centre
    this.$el.parentElement.firstChild.style="margin: auto";
  },
  methods: {
    updateChartOpex() {
      var opexTmp = this.opex;
      var opexLabels=Object.keys(opexTmp);
      // Extraction des labels
      this.chartData.datasets[0].label=opexLabels[0];
      this.chartData.datasets[1].label=opexLabels[1];
      this.chartData.datasets[2].label=opexLabels[2];
      this.chartData.datasets[3].label=opexLabels[3];
  
      var nbrPoints = 1.2 * this.maxVal;
      var pas = Math.round(this.maxVal / 100);
      const range = (start, stop, step = 1) =>
            Array(Math.ceil((stop - start) / step)).fill(start).map((x, y) => x + y * step);
      this.chartData.labels=range(0,nbrPoints,pas);

      // valorisation des données
      var matrice = [];
      var index = 0;
      opexLabels.forEach(function(e) {
          index = opexLabels.indexOf(e);
          var opexSpe = opexTmp[e];
          var opexSpeKeys = Object.keys(opexSpe);
          var thresholds = [];
          if(opexSpeKeys[0] != '0' && opexSpeKeys[0]!=0) {
            thresholds.push('0');
          }
          var costs = [];
          opexSpeKeys.forEach(function(elem) {
              if(!elem.startsWith('Sup')) {
                  thresholds.push(elem);
              }
              costs.push(opexSpe[elem]);
          });
          matrice.push([costs,thresholds,nbrPoints]);
          
      });
      this.originalematrice = matrice;
      this.calculateAllDatasets();
      document.getElementById('opex').value=JSON.stringify(this.originalematrice);
    },
    calculateAllDatasets() {
      for(let i = 0; i<this.chartData.datasets.length; i++) {
        this.calculateDataset(i);
      }
    },
    calculateDataset(datasetIndex) {
      var thresholds = this.originalematrice[datasetIndex][1];
      var costs = this.originalematrice[datasetIndex][0];
      var nbrPoints = this.originalematrice[datasetIndex][2];
      var pas = Math.round(this.maxVal / 100);
      var backgroundColors = [];
      var borderColors = [];
      var radiuses = [];
      var currentThreshold = 0;
      var data = [];
      for(var i=0; i<nbrPoints;i = i+pas) {
          if(i >= thresholds[currentThreshold+1] && currentThreshold < thresholds.length-1) {
              currentThreshold++;
              
          }
          if(i%pas == 0) {
              if(currentThreshold==thresholds.length-1){
                  data.push(costs[currentThreshold]);
              }else{
                var  m = (costs[currentThreshold+1]-costs[currentThreshold])/(thresholds[currentThreshold+1]-thresholds[currentThreshold]);
            
                var b = costs[currentThreshold] - m*thresholds[currentThreshold];
                
                data.push(b+i*m);
              }
              
          }
          if(thresholds.includes(""+i)){
            backgroundColors.push(colorPoint[datasetIndex]);
            borderColors.push(colorPoint[datasetIndex]);
            radiuses.push(10);
                
          }else{
            backgroundColors.push("White");
            borderColors.push(colorPoint[datasetIndex]);
            radiuses.push(5);
          }
      }
      this.chartData.datasets[datasetIndex].data = data;
      this.chartData.datasets[datasetIndex].backgroundColor = backgroundColors;
      this.chartData.datasets[datasetIndex].borderColor = borderColors;
      this.chartData.datasets[datasetIndex].radius = radiuses;
    },
    handleRightClick(e) {
      if(e.type == 'contextmenu') {
        e.native.preventDefault();
        var point = e.chart.getElementsAtEventForMode(e, 'nearest', { intersect: true }, false);
        this.removePoint(point);          
      } else if(e.type == 'click') {
        if(this.dblclickbool) {
          // THIS IS A DBL CLICK
          e.native.preventDefault();
          var point = e.chart.getElementsAtEventForMode(e, 'nearest', { intersect: true }, false);
          if(point.length) {
            let myModal = $("#modalpointOpex")[0];
            var rect = e.native.target.getBoundingClientRect();
            let val = this.chartData.datasets[point[0].datasetIndex].data[point[0].index];
            document.getElementById("modalNumberInputOpex").value=parseFloat(val);
            let posY = e.native.clientY - rect.y;
            myModal.style.display="flex";
            myModal.style.left = e.native.clientX + "px"; // set the modal position to the last stored position
            myModal.style.top = posY + "px";
            this.tempPoint = point;
          }
        } else {
          // THIS IS A FIRST CLICK
          this.dblclickbool= true;
          setTimeout(() => {
            this.dblclickbool = false;
          }, 500);
        }
      }
    },
    removePoint(point) {
      if(point.length) { // to filter out right click in empty space
        var datasetIndex = point[0].datasetIndex;
        var pointIndex = point[0].index;
        var pas = this.maxVal / 100;
        var indexASuppr = this.originalematrice[datasetIndex][1].indexOf(""+pointIndex*pas);
        console.log('Deleting a threshold : index ' + indexASuppr + ' for dataset '+datasetIndex);
        this.originalematrice[datasetIndex][1]=this.originalematrice[datasetIndex][1].splice(indexASuppr,1);
        this.originalematrice[datasetIndex][0]=this.originalematrice[datasetIndex][0].splice(indexASuppr,1);
        this.calculateDataset(datasetIndex);
      }
    },
    addPoint(point,value) {
      if(point.length) { // to filter out right click in empty space
        console.log('Creating a threshold : point ' + point + ' for value '+value);
        var datasetIndex = point[0].datasetIndex;
        var pointIndex = point[0].index;
        var pas = this.maxVal / 100;
        var newThreshold = pointIndex * pas;
        var indexACreer = 0;
        var thresholds = this.originalematrice[datasetIndex][1];
        while(thresholds[indexACreer] < newThreshold && indexACreer < thresholds.length) {
          indexACreer++;
        }
        if(thresholds[indexACreer] == newThreshold) {
          this.originalematrice[datasetIndex][1]=this.originalematrice[datasetIndex][1].splice(indexACreer,1,newThreshold+"");
          this.originalematrice[datasetIndex][0]=this.originalematrice[datasetIndex][0].splice(indexACreer,1,value);
        } else {
          this.originalematrice[datasetIndex][1]=this.originalematrice[datasetIndex][1].splice(indexACreer,0,newThreshold+"");
          this.originalematrice[datasetIndex][0]=this.originalematrice[datasetIndex][0].splice(indexACreer,0,value);
        }
        this.calculateDataset(datasetIndex);
      }
    },
    validateInput() {
      let value = $("#modalNumberInputOpex")[0].value;
      this.addPoint(this.tempPoint,value);
      let myModal = $("#modalpointOpex")[0];
      myModal.style.display="none";
      this.tempPoint=[];
    }
  },
  watch: {
    modeOpex() {
      this.updateChartOpex();
    }
  }
}
</script>
